import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, TextButton } from '@xingternal/button';
import { Header, Status } from '@xingternal/hops';
import { trackPageview } from '@xingternal/hops-tracking';
import { useExperiment } from '@xingternal/hub';
import { IconArrowLeft } from '@xingternal/icons';
import { IllustrationEmptyStateSuitcase } from '@xingternal/illustrations';
import { Row } from '@xingternal/xing-grid';

import { routes } from '@/config';
import { useLoginStates, useTrackNwtViewedScreen } from '@/hooks';

import * as S from './job-not-available.styles';

export const JobNotAvailable: React.FC = () => {
  const { isLoggedOut } = useLoginStates();

  // ABACUS-421
  const isVisionTypeSearch = useExperiment('ABACUS-421') === 'B';

  useTrackNwtViewedScreen({ page: 'jobs/empty_state_job_expired' });

  useEffect(() => {
    trackPageview('wbm/Stellenmarkt/empty_state_job_expired');
  }, []);

  return (
    <>
      <Header name="XING-CustomErrorPage" value="true" />
      <Status code={410} />

      <S.ButtonWrapper>
        <TextButton size="medium" icon={IconArrowLeft} to={isLoggedOut ? '/' : routes.visionTypeFind}>
          <FormattedMessage id="JOBS_POSTING_NAVIGATION_HOME" />
        </TextButton>
      </S.ButtonWrapper>

      <Row>
        <S.Info size={12}>
          <S.ImageWrapper>
            <IllustrationEmptyStateSuitcase />
          </S.ImageWrapper>

          <S.InfoTitle size="xxlarge">
            <FormattedMessage id="JOBS_NOT_AVAILABLE_PAGE_EXPLAINER_HEADLINE" />
          </S.InfoTitle>

          <S.InfoText size="medium">
            <FormattedMessage id="JOBS_NOT_AVAILABLE_PAGE_EXPLAINER_TEXT" />
          </S.InfoText>

          <Button variant="tertiary" size="medium" to={isVisionTypeSearch ? routes.visionTypeSearch : routes.search}>
            <FormattedMessage id="JOBS_NOT_AVAILABLE_PAGE_EXPLAINER_CTA" />
          </Button>
        </S.Info>
      </Row>
    </>
  );
};
